<div *ngIf="isShowTitle" class="header-title-container">
  <div class="container container-wrapper title-container">
    <h3>{{title | translate}}</h3>
  </div>
</div>
